<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import type { Bill } from './types';

  const dispatch = createEventDispatcher<{ editBill: Bill }>();
  export let bill: Bill = { id: 0, name: '', amount: '', duedate: '', frequency: '', url: '', inactive: false, fk_users: 0 };

  const handleSubmit = (): void => {
    dispatch('editBill', bill);
  };
</script>

<form on:submit|preventDefault={handleSubmit}>
  <label>
    <lblname>Biller</lblname>
    <input type="text" placeholder="biller" bind:value={bill.name} required>
  </label>
  <label>
    <lblname>Amount</lblname>
    <input type="text" placeholder="amount" bind:value={bill.amount} required>
  </label>
  <label>
    <lblname>Due Date</lblname>
    <input type="text" placeholder="due date" bind:value={bill.duedate} required>
  </label>
  <label>
    <lblname>Frequency</lblname>
    <input type="text" placeholder="frequency" bind:value={bill.frequency}><br>
  </label>
  <label>
    <lblname>URL</lblname>
    <input type="text" placeholder="url" bind:value={bill.url}><br>
  </label>
  <label>
    <lblname>Inactive</lblname>
    <input type="checkbox" placeholder="inactive" bind:checked={bill.inactive}><br>
  </label>
  <button class="button-primary">Edit bill</button>
</form>

<style>
  form {
    text-align: left;
  }
  lblname {
    display: block;
    font-weight: bold;
    font-size: 1em;
  }
  input {
    margin-bottom: 1em;
    width: 100%;
  }
  button {
    width: 100%;
  }
</style>